import { render, staticRenderFns } from "./InformationsComplementaires.vue?vue&type=template&id=a12cf71e&scoped=true"
import script from "./InformationsComplementaires.vue?vue&type=script&lang=js"
export * from "./InformationsComplementaires.vue?vue&type=script&lang=js"
import style0 from "./InformationsComplementaires.vue?vue&type=style&index=0&id=a12cf71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12cf71e",
  null
  
)

export default component.exports